import { useState } from 'react'
import clsx from 'clsx'

import CaseStudyCard from '../CaseStudyCard/CaseStudyCard'

import { AllCaseStudyPageAttributes } from '@/utils/queries/customer_case_study'

/* assets */
import { ReactComponent as ChevronRightIcon } from 'public/assets/icons/chevron-right-bold.svg'

interface Props {
  title: string
  data: {
    attributes: AllCaseStudyPageAttributes
  }[]
  isHomePage?: boolean
  showViewMore?: boolean
}

function MoreCaseStudies({
  title,
  data,
  isHomePage = false,
  showViewMore = true
}: Props) {
  const [displayCount, setDisplayCount] = useState(6)

  const handleViewMoreClick = () => {
    setDisplayCount(prevCount => prevCount + 3)
  }

  return (
    <section className="container | py-12 lg:py-16">
      <h2 className="font-heading text-3xl md:text-4xl font-semibold | max-w-col-8 mb-8 md:mb-12">
        {title}
      </h2>
      <div
        className={clsx(
          'grid grid-cols-1 md:grid-cols-2',
          isHomePage ? 'lg:grid-cols-3 gap-10 md:gap-8' : 'gap-11 md:gap-24',
          showViewMore ? 'mb-10 md:mb-18' : ''
        )}
      >
        <CaseStudyCard
          isHomePage={isHomePage}
          data={data.slice(0, displayCount).map(item => ({
            slug: item.attributes.slug,
            heroTitle: item.attributes.heroTitle,
            customerLogo: item.attributes.customerLogoWhite.data.attributes,
            caseStudyCardBgImage:
              item.attributes.caseStudyCardBgImage?.data?.attributes,
            statisticsList: item.attributes.statisticsList
          }))}
        />
      </div>

      {displayCount < data.length && showViewMore ? (
        <div className="flex justify-center items-center">
          <button
            onClick={() => handleViewMoreClick()}
            className="flex justify-center items-center gap-2 text-base text-blue-web-90 font-medium | border border-blue-web-90 rounded-lg | py-4 px-6"
          >
            View More Case Studies
            <ChevronRightIcon />
          </button>
        </div>
      ) : null}
    </section>
  )
}

export default MoreCaseStudies
